package horcrux.frontend.common.views.collections.collectiondialogs

import horcrux.common.api.dtos.EmbeddingModelID
import horcrux.common.utils.EnumCompanion
import horcrux.common.utils.StringEnum
import horcrux.frontend.common.State
import horcrux.frontend.common.views.components.containers.VStack
import horcrux.frontend.common.views.components.input.selectors.DropdownSelectorProps
import horcrux.frontend.common.views.components.input.selectors.dropdownSelector
import mui.material.DialogContentText
import mui.system.PropsWithSx
import mui.system.sx
import react.FC
import web.cssom.pt

enum class CollectionMediaType(
    override val stringValue: String,
    val embeddingModelID: EmbeddingModelID,
) : StringEnum {
    TEXT_ONLY("Text Only", EmbeddingModelID.TEXT_EMBEDDING_3_SMALL),
    TEXT_AND_IMAGES("Text and Images", EmbeddingModelID.CLIP_VIT_B_32);

    companion object : EnumCompanion<CollectionMediaType> {
        override val valuesList: List<CollectionMediaType> = CollectionMediaType.values().toList()
        val DropdownSelector: FC<DropdownSelectorProps<CollectionMediaType>> = this.dropdownSelector()
    }
}

external interface CollectionMediaTypeSelectorProps : PropsWithSx {
    var collectionMediaTypeState: State<CollectionMediaType>
}

val CollectionMediaTypeSelector = FC<CollectionMediaTypeSelectorProps> { props ->
    VStack {
        this.sx { +props.sx }
        DialogContentText {
            +"Select the collection media type"
        }
        CollectionMediaType.DropdownSelector {
            this.id = "embedding-model-type-dropdown-selector"
            this.currentValueState = props.collectionMediaTypeState
            this.helpTextMaybe =
                "Select the type of media that will be contained by this collection. If it will only contain text it's better to select ${CollectionMediaType.TEXT_ONLY.stringValue}. If it will contain images select ${CollectionMediaType.TEXT_AND_IMAGES.stringValue}."
            this.sx {
                this.marginTop = 10.pt
            }
        }
    }
}
